import { useAppState } from 'AppProvider';
import { isBrandSpecificFeatureEnabled } from './helper';

export default function useBrandToggleFeature(featureId) {
  const { settings } = useAppState((state) => state.brand);

  return isBrandSpecificFeatureEnabled(featureId, settings);
}
